/**
 * getType
 * @param {*} variable
 * @returns
 */
export const getType = function (variable: any) {
  return Object.prototype.toString.call(variable).slice(8, -1);
}

/**
 * isType
 * @param {*} variable
 * @returns
 */
export const isType = function (variable: any, type: string) {
  return getType(variable) === type;
}

export const isJDiwork = function () {
  let isJDiworkFlag = false;
  try {
    isJDiworkFlag = window.jDiwork && (window.name === '_WORKBENCH_' || window.parent.name === '_WORKBENCH_' || window.parent.parent.name === '_WORKBENCH_' || window.parent.parent.parent.name === '_WORKBENCH_')
  } catch (error) {
    console.log("Get jDiwork error", error);
  }
  return isJDiworkFlag
}